import { toKebabCase } from "@utils/string";

/**
 * Given a theme object, set global
 * theme vars
 *
 * Example experience.json:
 *
 * {
 *   ...
 *   theme: {
 *     primaryColor: '#000',
 *     secondaryColor: '#333',
 *     accentColor: '#f00',
 *     surfaceColor: '#fff',
 *     ...
 *   }
 * }
 *
 * @param {object} theme
 */
export function setTheme(theme = {}) {
  var customProperties = [];

  Object.entries(theme).forEach(([property, value]) => {
    customProperties.push(`--${toKebabCase(property)}: ${value}`);
  });

  document.documentElement.style.cssText = customProperties.join(";");
}
